import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Directive({
    selector: '[appRole]',
})
export class RoleDirective {
    private roles: string[] = [];

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private authService: AuthService) {}

    @Input()
    set appRole(roles: string[]) {
        this.roles = roles;
        this.updateView();
    }

    private updateView(): void {
        const userRoles = this.authService.ecosistema;
        const hasRole = this.roles.some((role) => userRoles.includes(role));

        if (hasRole) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
